import LinearProgress from '@mui/material/LinearProgress';
import { useQuery } from '@tanstack/react-query';
import React, { createContext, useContext } from 'react';
import { fetchTranslations } from '../../api/mobileapi';
import { translations } from '../../translations/translations';
import { useHomeData } from '../LoadHomeData/HomeDataProvider';

interface TranslationsContextValue {
    translations: Record<string, string>;
}

const TranslationsContext = createContext<TranslationsContextValue | undefined>(undefined);

interface TranslationsProviderProps {
    children: React.ReactNode;
}

export const TranslationsProvider: React.FC<TranslationsProviderProps> = ({ children }) => {
    const { currentLanguage } = useHomeData();
    const { data, isLoading } = useQuery(['translations'], () => fetchTranslations(), {
        initialData: translations,
        enabled: !!currentLanguage,
    });

    if (isLoading || !data[currentLanguage]) return <LinearProgress />;

    return (
        <TranslationsContext.Provider value={{ translations: data[currentLanguage] }}>
            <>{children}</>
        </TranslationsContext.Provider>
    );
};

export const useTranslations = () => {
    const value = useContext(TranslationsContext);
    if (value === undefined) {
        throw new Error();
    }
    return value;
};
